import React from 'react';

import ArrowLeft from 'mdi-react/ArrowLeftIcon';
import SearchBar from 'src/components/search-bar';

import { MobileSearchWrapper, CloseButton } from './styles';

type Props = {
  active: boolean;
  onClose: () => void;
  query: string;
  setQuery: (q: string) => void;
  clearQuery: () => void;
  onFocusChange: () => void;
  onBlurChange: () => void;
  autoFocusOnExpand: boolean;
  onCloseSuggestions: () => void;
  onOpenSuggestions: () => void;
  onClick: () => void;
  handleSearchInputRefCallback: (node: HTMLInputElement | null) => void;
  handleSearchWrapperRefUpdateCallback: (node: HTMLDivElement | null) => void;
};

export const SearchBarMobile = (props: Props) => {
  const {
    active,
    onClose,
    query,
    setQuery,
    clearQuery,
    onFocusChange,
    onBlurChange,
    autoFocusOnExpand,
    onCloseSuggestions,
    onOpenSuggestions,
    onClick,
    handleSearchInputRefCallback,
    handleSearchWrapperRefUpdateCallback,
  } = props;

  const handleClose = () => {
    clearQuery();
    onClose();
  };

  return (
    <MobileSearchWrapper $active={active}>
      {active && (
        <CloseButton onClick={handleClose}>
          <ArrowLeft />
        </CloseButton>
      )}

      <SearchBar
        query={query}
        setQuery={setQuery}
        clearQuery={clearQuery}
        onFocusChange={onFocusChange}
        onBlurChange={onBlurChange}
        autoFocusOnExpand={autoFocusOnExpand}
        onCloseSuggestions={onCloseSuggestions}
        onOpenSuggestions={onOpenSuggestions}
        onClick={onClick}
        handleSearchInputRefCallback={handleSearchInputRefCallback}
        handleSearchWrapperRefUpdateCallback={
          handleSearchWrapperRefUpdateCallback
        }
        isActive={active}
      />
    </MobileSearchWrapper>
  );
};
